// unable inspect for front-end users
/*
document.addEventListener('contextmenu', e => e.preventDefault());
document.addEventListener('keydown', function(e) {
  if (
    e.key === "F12" ||
    (e.ctrlKey && e.shiftKey && ["I","J","C"].includes(e.key)) ||
    (e.ctrlKey && e.key === "U")
  ) {
    e.preventDefault();
  }
});*/

jQuery(document).ready(function ($) {
  var mq = window.matchMedia("(max-width: 699.98px)");

  function handleToggle(e) {
    var isMobile = e.matches;

    $(".collection-description-mobile-wrap .collection-description").each(function () {
      var $desc = $(this);

      if (isMobile) {
        $desc.addClass("clamped");

        if (!$desc.next().hasClass("read-toggle")) {
          $desc.after(
            '<span class="read-toggle" style="cursor:pointer; display:block; margin-top:8px;">Read more...</span>'
          );
        }
      } else {
        $desc.removeClass("clamped");
        $desc.next(".read-toggle").remove();
      }
    });
  }

  handleToggle(mq);
  mq.addEventListener("change", handleToggle);

  $(document).on("click", ".read-toggle", function () {
    var $btn = $(this);
    var $desc = $btn.prev(".collection-description.desktop-hide");

    if ($desc.hasClass("clamped")) {
      $desc.removeClass("clamped");
      $btn.text("Read less");
    } else {
      $desc.addClass("clamped");
      $btn.text("Read more...");
    }
  });


  const variantChange = (event) => {
    var newVariant = event.detail.variant;
    var featured_id = newVariant.featured_media.id;

    console.log("New Featured => "+ featured_id);
    $(".product-gallery__thumbnail.variant-image").addClass("hidden").attr('aria-current',false);
    $(".product-gallery__thumbnail.variant-image[data-media-id='"+featured_id+"']").removeClass("hidden").attr('aria-current',true);
  }

  $('a[class^="letter"]').on("click", function(t) {
    t.preventDefault();
    const e = $(this).attr("class");
    $(".ingredient-glossary__accordion__content:visible").each(function() {
      $(this).animate({
        height: 0
      }, 400, function() {
        $(this).css("display", "none")
      })
    }),
    $('a[class^="letter"]').removeClass("active"),
    $(this).addClass("active"),
    $(".ingredient-glossary__letters__item").removeClass("active"),
    $(".ingredient-glossary__letters__item").hide(),
    $(".ingredient-glossary__letters__item." + e).addClass("active").show()
  })
  //start: manual gwp
  function fetchConfig(type = 'json') {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
    };
  }

  const cusManualGwpEqualizeCellHeights = ($carousel) => {
    try {
      if (!$carousel || !$carousel.length) return;
      const carouselEl = $carousel[0];

      const cellEls = Array.from(carouselEl.querySelectorAll('.custom--manual-gwp-each'));

      if (!cellEls.length) return;

      // Reset heights to measure natural content height.
      cellEls.forEach((el) => {
        el.style.height = '';
      });

      let max = 0;
      cellEls.forEach((el) => {
        // Skip detached/hidden nodes.
        if (!el.isConnected) return;
        const rect = el.getBoundingClientRect();
        if (rect.height > max) max = rect.height;
      });

      if (!max) return;
      const px = `${Math.ceil(max)}px`;
      cellEls.forEach((el) => {
        el.style.height = px;
      });
    } catch (_e) {}
  };

  const cusManualGwpBindEqualHeightImages = ($carousel) => {
    try {
      if (!$carousel || !$carousel.length) return;
      // Run once when any not-yet-loaded image loads.
      $carousel.find('img').each(function() {
        const img = this;
        if (!img || img.complete) return;
        $(img).one('load', function() {
          cusManualGwpEqualizeCellHeights($carousel);
          try { $carousel.slick('resize'); } catch (_e) {}
        });
      });
    } catch (_e) {}
  };

  const initSlickManualGWP = () => {
    console.log("Initialize");
    
    var $sections = $('.custom--manual-gwp-section .custom--manual-gwp-body');
    if ($sections.length > 0) {
      $sections.each(function() {
        const $section = $(this);
        if ($section.hasClass('slick-initialized')) return;

        // Initialize ASAP to avoid "stacked" flash after re-render.
        requestAnimationFrame(function() {
          if ($section.hasClass('slick-initialized')) return;

          $section.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            arrows: true,
            infinite: false,
            draggable: true,
            prevArrow: '<button class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0956/6342/3828/files/left-arrow.png?v=1773226831" width="7" height="14" alt="prev"></button>',
            nextArrow: '<button class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0956/6342/3828/files/right-arrow.png?v=1773226831" width="7" height="14" alt="next"></button>',
            adaptiveHeight: false,
            useTransform: true

          }).on('init', function(event, slick) {
            try {
              // Force correct initial alignment
              $(this).slick('setPosition');

              // Equalize cell heights
              cusManualGwpEqualizeCellHeights($section);
              cusManualGwpBindEqualHeightImages($section);

              try { $(this).slick('setPosition'); } catch (_e3) {}

              // One more resize after paint for stable measurements
              setTimeout(function() {
                try { $section.slick('setPosition'); } catch (_e2) {}
              }, 0);
            } catch (_e) {}

          }).on('afterChange', function(event, slick, currentSlide) {
            // settle equivalent — re-equalize after slide settles
            cusManualGwpEqualizeCellHeights($section);
          });
        });
      });
    }
  }

  const CUS_MANUAL_GWP_PROP_KEY = '_GWP_Sample';
  const CUS_MANUAL_GWP_PROP_VALUE = 'Free Gift';
  const CUS_MANUAL_FREE_SAMPLE_PROP_KEY = '_Free_Sample';
  const CUS_MANUAL_FREE_SAMPLE_PROP_VALUE = 'Free Gift';
  const CUS_MANUAL_FREE_SAMPLE_TIER_KEY = '_Free_Sample_Tier';
  const CUS_MANUAL_GWP_PENDING_MUTATION_KEY = 'cus_manual_gwp_pending_mutation_until';
  const CUS_MANUAL_GWP_PENDING_MUTATION_MS = 1200;
  const CUS_MANUAL_GWP_CLEANUP_KEY = 'cus_manual_gwp_cleanup_until';
  const CUS_MANUAL_GWP_CLEANUP_MS = 4000;

  // Free Samples
  const cusManualGwpIsFreeSampleItem = (item) =>
    (item?.properties || {})[CUS_MANUAL_FREE_SAMPLE_PROP_KEY] === CUS_MANUAL_FREE_SAMPLE_PROP_VALUE;

  const cusManualGwpGetTierConfig = () => {
    try {
      const el = document.querySelector('script[data-manual-gwp-tier-config]');
      return el ? JSON.parse(el.textContent) : null;
    } catch (_e) { return null; }
  };

  // Same maths as the Liquid: shippable items, minus free samples, minus cart-level discounts
  const cusManualGwpGetQualifyingTotal = (cart) => {
    const itemsTotal = (cart.items || []).reduce((sum, item) => {
      if (!item.requires_shipping || cusManualGwpIsFreeSampleItem(item)) return sum;
      return sum + (parseInt(item.final_line_price, 10) || 0);
    }, 0);
    const discount = (cart.cart_level_discount_applications || []).reduce(
      (sum, d) => sum + (parseInt(d.total_allocated_amount, 10) || 0), 0);
    return itemsTotal - discount;
  };

  // Free samples: tier maths (matches the Liquid). Everything else (GWP): original cart.total_price
  const cusManualGwpGetSectionTotal = (cart, manual_key) =>
    manual_key === CUS_MANUAL_FREE_SAMPLE_PROP_KEY
      ? cusManualGwpGetQualifyingTotal(cart)
      : cart.total_price;

  const cusManualGwpGetEligibleTier = (cart) => {
    const config = cusManualGwpGetTierConfig();
    if (!config) return null; // unknown -> don't touch the cart
    const total = cusManualGwpGetQualifyingTotal(cart);
    let tier = 0;
    config.tiers.forEach((t) => {
      if (t.threshold > 0 && total >= t.threshold) tier = Math.max(tier, t.tier);
    });
    return tier;
  };

  // Free samples that belong to a tier other than the current one
  const cusManualGwpGetStaleFreeSampleKeys = (cart) => {
    const tier = cusManualGwpGetEligibleTier(cart);
    if (tier === null) return [];
    return (cart.items || [])
      .filter((item) => cusManualGwpIsFreeSampleItem(item))
      .filter((item) => tier === 0 || String(item.properties?.[CUS_MANUAL_FREE_SAMPLE_TIER_KEY]) !== String(tier))
      .map((item) => item.key);
  };

  // Count selected gifts for a section (free samples are counted per tier)
  const cusManualGwpCountInCart = (cart, manual_key, tier) =>
    (cart.items || []).reduce((sum, item) => {
      const props = item?.properties || {};
      if (props[manual_key] !== CUS_MANUAL_GWP_PROP_VALUE) return sum;
      if (manual_key === CUS_MANUAL_FREE_SAMPLE_PROP_KEY &&
          String(props[CUS_MANUAL_FREE_SAMPLE_TIER_KEY]) !== String(tier)) return sum;
      return sum + (parseInt(item.quantity, 10) || 0);
    }, 0);

  const cusManualGwpGetMiniCart = () => document.querySelector('#cart-drawer');

  const cusManualGwpIsCartPage = () =>
    document.body.classList.contains('template-cart') || (typeof theme !== 'undefined' && location.pathname === themeVariables.routes.cart_url);

  const cusManualGwpMarkCleanupInProgress = () => {
    try {
      sessionStorage.setItem(CUS_MANUAL_GWP_CLEANUP_KEY, String(Date.now() + CUS_MANUAL_GWP_CLEANUP_MS));
    } catch (_e) {}
  };

  const cusManualGwpIsCleanupInProgress = () => {
    try {
      const until = parseInt(sessionStorage.getItem(CUS_MANUAL_GWP_CLEANUP_KEY) || '0', 10);
      return until > Date.now();
    } catch (_e) {
      return false;
    }
  };

  const cusManualGwpClearCleanupInProgress = () => {
    try { sessionStorage.removeItem(CUS_MANUAL_GWP_CLEANUP_KEY); } catch (_e) {}
  };

  const cusManualGwpMarkPendingMutation = () => {
    try {
      sessionStorage.setItem(CUS_MANUAL_GWP_PENDING_MUTATION_KEY, String(Date.now() + CUS_MANUAL_GWP_PENDING_MUTATION_MS));
    } catch (_e) {}
  };

  const cusManualGwpIsPendingMutation = () => {
    try {
      const until = parseInt(sessionStorage.getItem(CUS_MANUAL_GWP_PENDING_MUTATION_KEY) || '0', 10);
      return until > Date.now();
    } catch (_e) {
      return false;
    }
  };

  const cusManualGwpClearPendingMutation = () => {
    try { sessionStorage.removeItem(CUS_MANUAL_GWP_PENDING_MUTATION_KEY); } catch (_e) {}
  };

  const cusManualGwpGetCartJson = async () =>
    fetch('/cart.js', { method: 'GET', headers: { 'Accept': 'application/json' } }).then((r) => r.json());

  const cusManualGwpSetButtonState = ($btn, isChecked) => {
    $btn.toggleClass('is-checked', !!isChecked);
    $btn.attr('aria-pressed', !!isChecked);
    $btn.attr('aria-label', isChecked ? 'Selected' : 'Select');
  };

  const cusManualGwpGetLimitForSection = (sectionEl) => {
    const raw = sectionEl?.dataset?.itemLimit;
    const n = parseInt(raw, 10);
    // If no valid limit provided, treat as unlimited.
    return Number.isFinite(n) ? n : Infinity;
  };

  const cusManualGwpIsMatch = (item, variantId) => {
    if (!item) return false;
    if (parseInt(item.variant_id, 10) !== parseInt(variantId, 10)) return false;
    const props = item.properties || {};
    return props[CUS_MANUAL_GWP_PROP_KEY] === CUS_MANUAL_GWP_PROP_VALUE || props[CUS_MANUAL_FREE_SAMPLE_PROP_KEY] === CUS_MANUAL_GWP_PROP_VALUE;
  };

  const cusManualGwpSyncSelection = async () => {
    try {
      const $sections = $('.custom--manual-gwp-section');
      if ($sections.length === 0) return;

      const cart = await cusManualGwpGetCartJson();

      $sections.each(function() {
        const sectionEl = this;
        const $section = $(sectionEl);
        const threshold = $section.find("input[name='manual_gwp_threshold']").val();
        const manual_key = $section.find("input[name='manual_key']").val();
        const tier = $section.find("input[name='manual_tier']").val();
        
        const gwpQtyInCart = (cart.items || []).reduce((sum, item) => {
          const props = item?.properties || {};
          if (props[manual_key] === CUS_MANUAL_GWP_PROP_VALUE) {
            return sum + (parseInt(item.quantity, 10) || 0);
          }
          return sum;
        }, 0);

        const limit = cusManualGwpGetLimitForSection(sectionEl);
        const remaining = limit === Infinity ? Infinity : Math.max(0, limit - gwpQtyInCart);

        // Update "items left" text
        const $limitText = $section.find('.custom--manual-gwp-limit-text').first();
        if ($limitText.length) {
          if (limit === Infinity) {
            $limitText.text('');
          } else if (limit <= 0) {
            $limitText.text('No free gifts available.');
          } else {
            $limitText.text(`${remaining} Left to select`);
          }
        }

        $section.find('.round-check-btn[data-variant-id]').each(function() {
          const $btn = $(this);
          const variantId = $btn.data('variant-id');
          const inCart = (cart.items || []).some((item) => cusManualGwpIsMatch(item, variantId));
          cusManualGwpSetButtonState($btn, inCart);

          const $item = $btn.closest('.custom--manual-gwp-each');
          // Mark selected/active items for custom styling.
          $item.toggleClass('is-active', !!inCart);
          const shouldDisable = !inCart && limit !== Infinity && gwpQtyInCart >= limit;
          $item.toggleClass('is-disabled', !!shouldDisable);
          $btn.prop('disabled', !!shouldDisable);
          $btn.attr('aria-disabled', shouldDisable ? 'true' : 'false');
        });
      });
    } catch (e) {
      console.error('Manual GWP: failed to sync selection', e);
    }
  };

  const cusManualGwpRefreshSlick = () => {
    const $section = $('.custom--manual-gwp-section .custom--manual-gwp-body-wrapper');
    const $sectionBody = $('.custom--manual-gwp-section .custom--manual-gwp-body-wrapper .custom--manual-gwp-body');
    if ($section.length === 0) return;

    // Smooth refresh: hide cells until Slick is ready, show overlay during pending mutation (add/remove).
    const pendingMutation = cusManualGwpIsPendingMutation();

    $section.removeClass('is-ready').addClass('is-refreshing');
    if (pendingMutation) {
      $section.addClass('is-loading');
      $section.find('.custom-manual-gwp-loading-overlay').first().removeClass('hidden');
    }

    // If the drawer/cart re-rendered, Slick may need to be initialized again.
    if (!$sectionBody.hasClass('slick-initialized')) {
      initSlickManualGWP();
    } else {
      try {
        $sectionBody.slick('setPosition');
        cusManualGwpEqualizeCellHeights($sectionBody);
        cusManualGwpBindEqualHeightImages($sectionBody);
        try { $sectionBody.slick('setPosition'); } catch (_e2) {}
      } catch (e) {
        // If Slick instance is in a bad state (e.g. DOM swapped), re-init.
        try {
          if ($sectionBody.hasClass('slick-initialized')) {
            $sectionBody.slick('unslick');
          }
        } catch (_e) {}
        initSlickManualGWP();
      }
    }

    // Also keep checkmarks aligned with the actual cart state.
    cusManualGwpSyncSelection();

    // End smooth refresh once Slick is ready (or after a short timeout).
    const startedAt = Date.now();
    const finish = () => {
      const $nowWrapper = $('.custom--manual-gwp-section .custom--manual-gwp-body-wrapper');
      const $now = $('.custom--manual-gwp-section .custom--manual-gwp-body');
      if ($now.length === 0) return;

      const ready = $now.hasClass('slick-initialized');
      const timedOut = (Date.now() - startedAt) > 1400;
      if (!ready && !timedOut) {
        requestAnimationFrame(finish);
        return;
      }

      $nowWrapper.removeClass('is-refreshing').addClass('is-ready');
      // If we deferred showing the section (cart page), reveal it once Slick is stable.
      $nowWrapper.closest('.custom--manual-gwp-section').removeClass('is-deferred-hidden').addClass('is-deferred-ready');
      // Clear pending mutation once the refreshed UI is stable.
      if (cusManualGwpIsPendingMutation()) cusManualGwpClearPendingMutation();
      $nowWrapper.removeClass('is-loading');
      $section.find('.custom-manual-gwp-loading-overlay').first().addClass('hidden');
    };
    requestAnimationFrame(finish);
  };

  const cusManualGwpSetLoading = (scopeEl, isLoading) => {
    const $body = $(scopeEl).closest('.custom--manual-gwp-section').find('.custom--manual-gwp-body-wrapper').first();
    if ($body.length === 0) return;

    $body.toggleClass('is-loading', !!isLoading);
    const $overlay = $body.find('.custom-manual-gwp-loading-overlay').first();
    if ($overlay.length) $overlay.toggleClass('hidden', !isLoading);
  };

  const cusManualGwpRemoveFromCart = async (variantId) => {
    const cart = await cusManualGwpGetCartJson();
    const items = cart.items || [];
    const matchIndex = items.findIndex((item) => cusManualGwpIsMatch(item, variantId));
    if (matchIndex === -1) return;

    // Shopify "line" is 1-based.
    const line = matchIndex + 1;
    const key = items[matchIndex]?.key;

    // On cart page, rely on the existing cart page renderer.
    if (cusManualGwpIsCartPage()) {
      const cartItemsEl = document.querySelector('line-item');
      if (cartItemsEl && typeof cartItemsEl.updateQuantity === 'function') {
        cartItemsEl.updateQuantity(line, 0);
        return;
      }
      window.location.reload();
      return;
    }

    // In cart drawer / non-cart pages, request updated sections and re-render the drawer.
    const body = JSON.stringify({
      ...(key ? { id: key } : { line: line }),
      quantity: 0,
      sections_url: window.location.pathname
    });

    const parsedState = await fetch(`${themeVariables.routes.cart_change_url}`, { ...fetchConfig(), body }).then((r) => r.json());
    cusManualGwpRenderCartPageSections();
  };

  const cusManualGwpRenderCartPageSections = () => {
    if (window.themeVariables.settings.pageType === "cart") {
      window.location.reload();
    }else{
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:refresh', { bubbles: true })
      );
      setTimeout(cusManualGwpRefreshSlick, 1000);
    }
  };

  const cusManualGwpRemoveItemsByKeys = async (keys, opts = {}) => {
    const uniqueKeys = Array.from(new Set((keys || []).filter(Boolean)));
    if (uniqueKeys.length === 0) return;

    const shouldReloadCartPage = !!opts.reloadCartPage;
    const updates = uniqueKeys.reduce((acc, k) => {
      acc[k] = 0;
      return acc;
    }, {});

    const body = JSON.stringify({
      updates,
      sections_url: window.location.pathname
    });

    const parsedState = await fetch(`${themeVariables.routes.cart_update_url}`, { ...fetchConfig(), body }).then((r) => r.json());
    if(shouldReloadCartPage){
      window.location.reload();
    }else{
      cusManualGwpRenderCartPageSections();
    }
  };

  const cusManualGwpEnforceNoGwpOnlyCheckout = async () => {
    if (cusManualGwpIsCleanupInProgress()) return;

    try {
      const $sections = $('.custom--manual-gwp-section');

      const cart = await cusManualGwpGetCartJson();
      const items = cart.items || [];
      if (items.length === 0) return;

      const staleKeys = cusManualGwpGetStaleFreeSampleKeys(cart);
      if (staleKeys.length > 0) {
        cusManualGwpMarkCleanupInProgress();
        await cusManualGwpRemoveItemsByKeys(staleKeys);
        return;
      }

      const cartTotal = cart.total_price;

      const allKeysToRemove = new Set();

      if($sections.length > 1){
        const promises = [];
        $sections.each(function () {
          promises.push((async () => {
            const $section = $(this);
            const threshold = parseFloat($section.find("input[name='manual_gwp_threshold']").val());
            const manual_key = $section.find("input[name='manual_key']").val();

            const gwpItems = items.filter((item) => {
              const props = item?.properties || {};
              return props[manual_key] === CUS_MANUAL_GWP_PROP_VALUE;
            });
            if (gwpItems.length === 0) return;

            const hasNonGwpItem = items.some((item) => {
              const props = item?.properties || {};
              return props[manual_key] !== CUS_MANUAL_GWP_PROP_VALUE;
            });

            const belowThreshold = !isNaN(threshold) && threshold !== Infinity && threshold > 0 && cartTotal < threshold;
            if (!hasNonGwpItem || belowThreshold) {
              gwpItems.forEach((i) => allKeysToRemove.add(i.key));
            }
            
            if (allKeysToRemove.size > 0) {
              cusManualGwpMarkCleanupInProgress();
              await cusManualGwpRemoveItemsByKeys([...allKeysToRemove]);
            }
          })());
        });
        await Promise.all(promises);
      }else if($sections.length == 1){
        const promises = [];
        $sections.each(function () {
          promises.push((async () => {
            const $section = $(this);
            const threshold = parseFloat($section.find("input[name='manual_gwp_threshold']").val());
            const manual_key = $section.find("input[name='manual_key']").val();

            const gwpItems = items.filter((item) => {
              const props = item?.properties || {};
              return props[manual_key] === CUS_MANUAL_GWP_PROP_VALUE;
            });
            if (gwpItems.length === 0) return;

            const hasNonGwpItem = items.some((item) => {
              const props = item?.properties || {};
              return props[manual_key] !== CUS_MANUAL_GWP_PROP_VALUE;
            });

            const belowThreshold = !isNaN(threshold) && threshold !== Infinity && threshold > 0 && cartTotal < threshold;
            if (!hasNonGwpItem || belowThreshold) {
              gwpItems.forEach((i) => allKeysToRemove.add(i.key));
            }

            if(manual_key == CUS_MANUAL_FREE_SAMPLE_PROP_KEY){
              const gwpManualItems = items.filter((item) => {
                const props = item?.properties || {};
                return props[CUS_MANUAL_GWP_PROP_KEY] === CUS_MANUAL_GWP_PROP_VALUE;
              });

              if (gwpManualItems.length > 0){
                gwpManualItems.forEach((i) => allKeysToRemove.add(i.key));
              }
            }else if(manual_key == CUS_MANUAL_GWP_PROP_KEY){
              const gwpFreeItems = items.filter((item) => {
                const props = item?.properties || {};
                return props[CUS_MANUAL_FREE_SAMPLE_PROP_KEY] === CUS_MANUAL_GWP_PROP_VALUE;
              });

              if (gwpFreeItems.length > 0){
                gwpFreeItems.forEach((i) => allKeysToRemove.add(i.key));
              }
            }
            
            if (allKeysToRemove.size > 0) {
              cusManualGwpMarkCleanupInProgress();
              await cusManualGwpRemoveItemsByKeys([...allKeysToRemove]);
            }
          })());
        });
        await Promise.all(promises);
      }else{
        const gwpItems = items.filter((item) => {
          const props = item?.properties || {};
          return props[CUS_MANUAL_GWP_PROP_KEY] === CUS_MANUAL_GWP_PROP_VALUE || props[CUS_MANUAL_FREE_SAMPLE_PROP_KEY] === CUS_MANUAL_GWP_PROP_VALUE;
        });
        if (gwpItems.length === 0) return;

        cusManualGwpMarkCleanupInProgress();
        // Remove all at once for speed + reliability.
        const keys = gwpItems.map((i) => i.key);
        await cusManualGwpRemoveItemsByKeys(keys);
      }
    } catch (e) {
      console.error('Manual GWP: failed enforcing no-GWP-only cart', e);
    } finally {
      cusManualGwpClearCleanupInProgress();
    }
  };
  
  const cusManualGwpAddToCart = async (manual_key, variantId, tier=1) => {
    const properties = {};
    properties[manual_key] = CUS_MANUAL_GWP_PROP_VALUE;
    if (manual_key === CUS_MANUAL_FREE_SAMPLE_PROP_KEY && tier) {
      properties[CUS_MANUAL_FREE_SAMPLE_TIER_KEY] = String(tier);
    }

    const body = JSON.stringify({
      id: variantId,
      quantity: 1,
      properties: properties,
      sections_url: window.location.pathname
    });

    const parsedState = await fetch(`${themeVariables.routes.cart_add_url}`, { ...fetchConfig(), body }).then((r) => r.json());

    cusManualGwpRenderCartPageSections();
  };

  const toggleCheck = async (e) => {
    const $btn = $(e);
    const $parentSection = $(e).closest(".custom--manual-gwp-section");
    const threshold = $parentSection.find("input[name='manual_gwp_threshold']").val();
    const manual_key = $parentSection.find("input[name='manual_key']").val();
    const tier = $parentSection.find("input[name='manual_tier']").val();
    const variantId = $btn.data('variant-id');
    if (!variantId) return;

    // Enforce item limit (do not allow adding if limit is reached)
    if (!$btn.hasClass('is-checked')) {
      const limit = cusManualGwpGetLimitForSection($parentSection);
      if (limit !== Infinity && limit >= 0 && threshold != Infinity && threshold > 0) {
        try {
          const cart = await fetch('/cart.js', { method: 'GET', headers: { 'Accept': 'application/json' } }).then((r) => r.json());
          const gwpQtyInCart = (cart.items || []).reduce((sum, item) => {
            const props = item?.properties || {};
            if (props[manual_key] === CUS_MANUAL_GWP_PROP_VALUE) {
              return sum + (parseInt(item.quantity, 10) || 0);
            }
            return sum;
          }, 0);

          if (gwpQtyInCart >= limit && cart.total_price >= threshold) {
            cusManualGwpSyncSelection();
            return;
          }
        } catch (_e) {}

        try {
        const cart = await cusManualGwpGetCartJson();
        const gwpQtyInCart = cusManualGwpCountInCart(cart, manual_key, tier);
        if (gwpQtyInCart >= limit && cusManualGwpGetSectionTotal(cart, manual_key) >= threshold) {
          cusManualGwpSyncSelection();
          return;
        }
      } catch (_e) {}
      }
    }

    if ($btn.data('manual-gwp-loading')) return;
    $btn.data('manual-gwp-loading', true);
    $btn.prop('disabled', true);

    // Show overlay for both add and remove.
    const willAdd = !$btn.hasClass('is-checked');
    cusManualGwpMarkPendingMutation();
    cusManualGwpSetLoading(e, true);

    try {
      if ($btn.hasClass('is-checked')) {
        await cusManualGwpRemoveFromCart(variantId);
      } else {
        await cusManualGwpAddToCart(manual_key, variantId, tier);
      }
    } catch (err) {
      console.error('Manual GWP: toggle failed', err);
    } finally {
      $btn.data('manual-gwp-loading', false);
      $btn.prop('disabled', false);
      cusManualGwpSetLoading(e, false);
      cusManualGwpSyncSelection();
    }
  }

  // Allow clicking the whole container, not just the button.
  $(document).on('click', '.custom--manual-gwp-section .custom--manual-gwp-atc .round-check-btn', function(evt) {
    if ($(this).closest('.custom--manual-gwp-each').hasClass('is-disabled')) return;
    toggleCheck(this);
  });

  $(function() {
    if (cusManualGwpIsCartPage()) {
      const hasDeferred = $('.custom--manual-gwp-section.is-deferred-hidden[data-defer-until-load="true"]').length > 0;
      if (!hasDeferred) setTimeout(cusManualGwpRefreshSlick, 0);
      setTimeout(cusManualGwpEnforceNoGwpOnlyCheckout, 0);
    }
  });

  $(window).on('load', function() {
    if (cusManualGwpIsCartPage()) {
      cusManualGwpRefreshSlick();
      setTimeout(cusManualGwpRefreshSlick, 250);
    }
  });
  //end: manual gwp

  const originalDispatch = EventTarget.prototype.dispatchEvent;
  EventTarget.prototype.dispatchEvent = function(event) {
    if (event.type == "variant:change"){
      variantChange(event);
    }else if (event.type == "dialog:after-show"){
      cusManualGwpRefreshSlick();
    }else if (event.type == "cart-updated" || event.type == "cart:change"){
      console.log("Cart Updated");
      setTimeout(cusManualGwpRefreshSlick, 500);
      setTimeout(cusManualGwpEnforceNoGwpOnlyCheckout, 500);
    }
    originalDispatch.call(this, event);
  };

  (function () {
    // 1. Wishlist redesign
    const wishlistStyleId = 'custom-wishlist-style';

    function styleWishlist(wishlist) {
      if (wishlist.tagName !== 'JOY-WISHLIST-BUTTON') return;

      const shadow = wishlist.shadowRoot;
      if (!shadow || shadow.querySelector('#' + wishlistStyleId)) return;

      const style = document.createElement('style');
      style.id = wishlistStyleId;
      style.textContent = `
        .Joy-Wishlist__Button {
          background: transparent !important;
          background-color: transparent !important;
        }
      `;

      shadow.appendChild(style);
    }

    function processWishlistNode(node) {
      if (node.nodeType !== 1) return;

      styleWishlist(node);
      node.querySelectorAll?.('joy-wishlist-button').forEach(styleWishlist);
    }

    document.querySelectorAll('joy-wishlist-button').forEach(styleWishlist);

    // Observe only element additions, not attributes.
    const wishlistObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach(processWishlistNode);
      });
    });

    wishlistObserver.observe(document.documentElement, {
      childList: true,
      subtree: true
    });


    // 2. Star icon redesign
    function removeStarStyles(root) {
      if (root.nodeType !== 1) return;

      const selector =
        '.custom-collection-page-v2 [data-bv-show="inline_rating"] svg[style]';

      if (root.matches?.(selector)) {
        root.removeAttribute('style');
      }

      root.querySelectorAll?.(selector).forEach((svg) => {
        svg.removeAttribute('style');
      });
    }

    document.querySelectorAll('.custom-collection-page-v2').forEach((page) => {
      removeStarStyles(page);

      const starObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach(removeStarStyles);
        });
      });

      starObserver.observe(page, {
        childList: true,
        subtree: true
      });
    });
  })();

  // gift card radio button change
  document.addEventListener('change', function (event) {
    if (!event.target.matches('.variant-radio-group input[type="radio"]')) return;

    const group = event.target.closest('.variant-radio-group');

    group.querySelectorAll('.variant-radio-pill').forEach(function (pill) {
      pill.classList.toggle(
        'is-selected',
        pill.querySelector('input').checked
      );
    });
  });
});

